
import React, { createContext, useState, useContext } from 'react';

export const CartContext = createContext();

export function CartProvider({ children }) {
    const [cartItems, setCartItems] = useState([]);

    const addToCart = (product) => {
        setCartItems(prevItems => {
            const existingItem = prevItems.find(item => item._id === product._id);

            // Stock validation for new items
            if (!existingItem && product.quantity <= 0) {
                alert("This product is out of stock");
                return prevItems;
            }

            // Stock validation for existing items
            if (existingItem && existingItem.quantity >= product.stock) {
                alert(`You've reached the maximum available quantity (${product.stock})`);
                return prevItems;
            }

            if (existingItem) {
                return prevItems.map(item =>
                    item._id === product._id
                        ? { ...item, quantity: item.quantity + 1 }
                        : item
                );
            }

            return [...prevItems, {
                ...product,
                quantity: 1,
                stock: product.quantity // Store original stock
            }];
        });
    };

    const removeFromCart = (productId) => {
        setCartItems(prevItems => {
            const existingItem = prevItems.find(item => item._id === productId);
            if (existingItem && existingItem.quantity > 1) {
                return prevItems.map(item =>
                    item._id === productId
                        ? { ...item, quantity: item.quantity - 1 }
                        : item
                );
            }
            return prevItems.filter(item => item._id !== productId);
        });
    };

    const clearCart = () => {
        setCartItems([]);
    };

    const cartTotal = cartItems.reduce(
        (total, item) => total + (item.price * item.quantity), 0
    );

    return (
        <CartContext.Provider value={{
            cartItems,
            addToCart,
            removeFromCart,
            clearCart,
            cartTotal
        }}>
            {children}
        </CartContext.Provider>
    );
}

export function useCart() {
    return useContext(CartContext);
}